import type { Locale } from '../../i18n';

const RU = {
  'ops.title': 'Эксплуатация',
  'ops.subtitle': 'Состояние ядра, устройства, релизы, резервные копии и резидентность',
  'ops.loading': 'Загрузка…',
  'ops.refresh': 'Обновить',
  'ops.empty': 'Нет данных',
  'ops.save': 'Сохранить',

  'ops.tab.health': 'Наблюдаемость',
  'ops.tab.devices': 'Устройства',
  'ops.tab.releases': 'Релизы',
  'ops.tab.backups': 'Копии и учения',
  'ops.tab.residency': 'Резидентность',

  'ops.health.title': 'Состояние ядра',
  'ops.health.status': 'Статус',
  'ops.health.latency': 'Отклик, мс',
  'ops.health.check': 'Проверка',
  'ops.health.detail': 'Подробности',
  'ops.health.ok': 'Норма',
  'ops.health.degraded': 'Деградация',
  'ops.health.down': 'Недоступно',
  'ops.health.availability': 'Доступность за 30 дней',
  'ops.health.samples': 'Замеров',
  'ops.health.target': 'Цель — 99,5 % в рабочие часы, замеряется внешним мониторингом',

  'ops.alerts.title': 'Открытые сработки',
  'ops.alerts.metric': 'Показатель',
  'ops.alerts.scope': 'Разрез',
  'ops.alerts.observed': 'Значение',
  'ops.alerts.threshold': 'Порог',
  'ops.alerts.cmp.gt': 'срабатывает, когда значение больше порога',
  'ops.alerts.cmp.lt': 'срабатывает, когда значение меньше порога',
  'ops.alerts.cmp.eq': 'срабатывает при точном совпадении с порогом',
  'ops.alerts.severity': 'Важность',
  'ops.alerts.raised': 'Поднята',
  'ops.alerts.none': 'Открытых сработок нет',
  'ops.alerts.rules': 'Пороги',
  'ops.alerts.enabled': 'Включён',
  'ops.alerts.description': 'Описание',

  'ops.devices.title': 'Инвентарь планшетов и касс',
  'ops.devices.add': 'Поставить устройство на учёт',
  'ops.devices.addKind': 'Что ставим',
  'ops.devices.addSite': 'Объект',
  'ops.devices.addLabel': 'Название',
  'ops.devices.addLabelHint': 'Как это устройство называют на объекте: «Планшет у въезда», «Касса 1»',
  'ops.devices.addSubmit': 'Поставить на учёт',
  'ops.devices.addForbidden': 'Ставить устройства на учёт может администратор сети',
  'ops.devices.tokenTitle': 'Токен устройства',
  'ops.devices.tokenOnce':
    'Токен показывается один раз: в базе хранится только его хеш. Перенесите его на устройство сейчас — если потеряете, поставьте устройство на учёт заново, а эту запись отзовите.',
  'ops.devices.tokenCopy': 'Скопировать',
  'ops.devices.tokenCopied': 'Скопировано',
  'ops.devices.openAt': 'Открыть на устройстве:',
  'ops.devices.name': 'Название',
  'ops.devices.id': 'Идентификатор',
  'ops.devices.site': 'Объект',
  'ops.devices.kind': 'Вид',
  'ops.devices.label': 'Название',
  'ops.devices.version': 'Версия',
  'ops.devices.lastSeen': 'Последняя связь',
  'ops.devices.queue': 'Очередь',
  'ops.devices.status': 'Статус',
  'ops.devices.online': 'На связи',
  'ops.devices.offline': 'Нет связи',
  'ops.devices.active': 'Активно',
  'ops.devices.revoked': 'Отозвано',
  'ops.devices.revoke': 'Отозвать доступ',
  'ops.devices.revokeReason': 'Причина отзыва',
  'ops.devices.tablet': 'Планшет',
  'ops.devices.pos': 'Касса',
  'ops.devices.sync': 'Состояние синхронизации',
  'ops.devices.conflicts': 'Открытых конфликтов',
  'ops.devices.offlineCount': 'Устройств без связи',

  'ops.releases.title': 'История релизов',
  'ops.releases.version': 'Версия',
  'ops.releases.channel': 'Контур',
  'ops.releases.status': 'Статус',
  'ops.releases.before': 'Точка возврата',
  'ops.releases.after': 'Версия схемы',
  'ops.releases.started': 'Начат',
  'ops.releases.rollback': 'План отката',
  'ops.releases.rollbackNote':
    'Откат выполняется на сервере командой из плана: ядро останавливается, миграции релиза снимаются, поднимается предыдущий образ. Отметка «откачен» появляется только после проверки схемы и образа',
  'ops.releases.image': 'Образ',
  'ops.releases.plan':
    'Схема {from} → {to}, снимается миграций: {steps}. Образ {imageFrom} → {imageTo}. Выполните на сервере: {command}',
  'ops.releases.outsideWindow': 'вне окна: {reason}',
  'ops.releases.rollbackError': 'откат остановлен: {error}',

  'ops.backups.title': 'Резервные копии',
  'ops.backups.kind': 'Вид',
  'ops.backups.status': 'Статус',
  'ops.backups.size': 'Размер',
  'ops.backups.offsite': 'Вне площадки',
  'ops.backups.finished': 'Завершена',
  'ops.backups.drills': 'Учения по восстановлению',
  'ops.backups.runDrill': 'Провести учение по последней копии',
  'ops.backups.runBackup': 'Снять копию сейчас',
  'ops.backups.running': 'Выполняется…',
  'ops.backups.checkThis': 'Проверить',
  'ops.backups.checkThisHint': 'Развернуть эту копию во временную базу и сверить',
  'ops.backups.doneBackup': 'Копия снята: {size}',
  'ops.backups.donePassed': 'Учение пройдено: {tables} таблиц, расхождений нет, {rto} с',
  'ops.backups.doneFailed': 'Учение не пройдено: расхождений {mismatches}',
  'ops.backups.restoreNote':
    'Восстановления поверх рабочей базы здесь нет намеренно: в аварии эта панель лежит вместе с сервером, а операция необратима. Порядок восстановления — в operations/runbook-backup.md.',
  'ops.backups.rto': 'Время восстановления, с',
  'ops.backups.mismatches': 'Расхождений',
  'ops.backups.tables': 'Таблиц сверено',
  'ops.backups.passed': 'Пройдено',
  'ops.backups.failed': 'Не пройдено',
  'ops.backups.note':
    'Здесь видно, снимаются ли копии базы и восстанавливаются ли они на самом деле. Учение поднимает последнюю копию во временную базу и сверяет её: копия, которую не восстанавливали, копией не считается.',
  'ops.backups.toolsMissing': 'Копии и учения на этом контуре недоступны',
  'ops.backups.toolsMissingWhy':
    'Не найдены утилиты pg_dump и pg_restore. На машине разработчика postgresql-client обычно не установлен, а база живёт в контейнере — тогда утилиты запускают внутри него. Задайте в .env: MOIKA_PG_TOOL_PREFIX="docker exec -i moika-pg", MOIKA_PG_TOOL_URL="postgresql://moika:moika@127.0.0.1:5432/moika" и MOIKA_BACKUP_DIR=/var/lib/postgresql/backups, затем перезапустите сервер. В боевом контуре утилиты стоят в образе, и префикс оставляют пустым.',
  'ops.backups.toolsPrefix': 'Текущий префикс запуска',
  'ops.backups.toolsNotSet': 'не задан',

  'ops.residency.title': 'Реестр резидентности внешних сервисов',
  'ops.residency.code': 'Код',
  'ops.residency.name': 'Сервис',
  'ops.residency.category': 'Категория',
  'ops.residency.pii': 'Обрабатывает ПДн',
  'ops.residency.country': 'Страна размещения',
  'ops.residency.verdict': 'Вердикт',
  'ops.residency.evidence': 'Обоснование',
  'ops.residency.pending': 'Не проверен',
  'ops.residency.approved': 'Допущен',
  'ops.residency.rejected': 'Исключён',
  'ops.residency.compliant': 'Все сервисы проверены',
  'ops.residency.incomplete': 'Не проверено сервисов: {n}',
  'ops.residency.note':
    'Сервис, обрабатывающий персональные данные за пределами РК, допустить нельзя — ТЗ 8.4, Закон РК № 94-V',
};

const KK: Record<keyof typeof RU, string> = {
  'ops.title': 'Пайдалану',
  'ops.subtitle': 'Ядро күйі, құрылғылар, шығарылымдар, сақтық көшірмелер және резиденттік',
  'ops.loading': 'Жүктелуде…',
  'ops.refresh': 'Жаңарту',
  'ops.empty': 'Дерек жоқ',
  'ops.save': 'Сақтау',

  'ops.tab.health': 'Бақылау',
  'ops.tab.devices': 'Құрылғылар',
  'ops.tab.releases': 'Шығарылымдар',
  'ops.tab.backups': 'Көшірмелер мен жаттығулар',
  'ops.tab.residency': 'Резиденттік',

  'ops.health.title': 'Ядро күйі',
  'ops.health.status': 'Күйі',
  'ops.health.latency': 'Жауап, мс',
  'ops.health.check': 'Тексеру',
  'ops.health.detail': 'Толығырақ',
  'ops.health.ok': 'Қалыпты',
  'ops.health.degraded': 'Нашарлау',
  'ops.health.down': 'Қолжетімсіз',
  'ops.health.availability': '30 күндегі қолжетімділік',
  'ops.health.samples': 'Өлшемдер',
  'ops.health.target': 'Мақсат — жұмыс сағаттарында 99,5 %, сыртқы мониторингпен өлшенеді',

  'ops.alerts.title': 'Ашық ескертулер',
  'ops.alerts.metric': 'Көрсеткіш',
  'ops.alerts.scope': 'Қима',
  'ops.alerts.observed': 'Мәні',
  'ops.alerts.threshold': 'Шек',
  'ops.alerts.cmp.gt': 'мән шектен үлкен болғанда іске қосылады',
  'ops.alerts.cmp.lt': 'мән шектен кіші болғанда іске қосылады',
  'ops.alerts.cmp.eq': 'шекпен дәл сәйкес келгенде іске қосылады',
  'ops.alerts.severity': 'Маңыздылығы',
  'ops.alerts.raised': 'Көтерілді',
  'ops.alerts.none': 'Ашық ескертулер жоқ',
  'ops.alerts.rules': 'Шектер',
  'ops.alerts.enabled': 'Қосулы',
  'ops.alerts.description': 'Сипаттама',

  'ops.devices.title': 'Планшеттер мен кассалар түгендеуі',
  'ops.devices.add': 'Құрылғыны есепке қою',
  'ops.devices.addKind': 'Не қоямыз',
  'ops.devices.addSite': 'Нысан',
  'ops.devices.addLabel': 'Атауы',
  'ops.devices.addLabelHint': 'Нысанда бұл құрылғыны қалай атайды: «Кірудегі планшет», «1-касса»',
  'ops.devices.addSubmit': 'Есепке қою',
  'ops.devices.addForbidden': 'Құрылғыны есепке қоюды желі әкімшісі жасай алады',
  'ops.devices.tokenTitle': 'Құрылғы токені',
  'ops.devices.tokenOnce':
    'Токен бір рет көрсетіледі: базада тек оның хеші сақталады. Оны құрылғыға қазір көшіріңіз — жоғалтсаңыз, құрылғыны қайта есепке қойып, бұл жазбаны қайтарып алыңыз.',
  'ops.devices.tokenCopy': 'Көшіру',
  'ops.devices.tokenCopied': 'Көшірілді',
  'ops.devices.openAt': 'Құрылғыда ашыңыз:',
  'ops.devices.name': 'Атауы',
  'ops.devices.id': 'Идентификатор',
  'ops.devices.site': 'Нысан',
  'ops.devices.kind': 'Түрі',
  'ops.devices.label': 'Атауы',
  'ops.devices.version': 'Нұсқасы',
  'ops.devices.lastSeen': 'Соңғы байланыс',
  'ops.devices.queue': 'Кезек',
  'ops.devices.status': 'Күйі',
  'ops.devices.online': 'Байланыста',
  'ops.devices.offline': 'Байланыс жоқ',
  'ops.devices.active': 'Белсенді',
  'ops.devices.revoked': 'Қайтарып алынған',
  'ops.devices.revoke': 'Рұқсатты қайтарып алу',
  'ops.devices.revokeReason': 'Қайтарып алу себебі',
  'ops.devices.tablet': 'Планшет',
  'ops.devices.pos': 'Касса',
  'ops.devices.sync': 'Синхрондау күйі',
  'ops.devices.conflicts': 'Ашық қайшылықтар',
  'ops.devices.offlineCount': 'Байланыссыз құрылғылар',

  'ops.releases.title': 'Шығарылымдар тарихы',
  'ops.releases.version': 'Нұсқа',
  'ops.releases.channel': 'Контур',
  'ops.releases.status': 'Күйі',
  'ops.releases.before': 'Қайтару нүктесі',
  'ops.releases.after': 'Схема нұсқасы',
  'ops.releases.started': 'Басталды',
  'ops.releases.rollback': 'Кері қайтару жоспары',
  'ops.releases.rollbackNote':
    'Кері қайтару серверде жоспардағы командамен орындалады: ядро тоқтайды, шығарылым көші-қоны алынады, алдыңғы бейне көтеріледі. «Қайтарылды» белгісі схема мен бейне тексерілгеннен кейін ғана қойылады',
  'ops.releases.image': 'Бейне',
  'ops.releases.plan':
    'Схема {from} → {to}, алынатын көші-қон: {steps}. Бейне {imageFrom} → {imageTo}. Серверде орындаңыз: {command}',
  'ops.releases.outsideWindow': 'терезеден тыс: {reason}',
  'ops.releases.rollbackError': 'кері қайтару тоқтады: {error}',

  'ops.backups.title': 'Сақтық көшірмелер',
  'ops.backups.kind': 'Түрі',
  'ops.backups.status': 'Күйі',
  'ops.backups.size': 'Өлшемі',
  'ops.backups.offsite': 'Алаңнан тыс',
  'ops.backups.finished': 'Аяқталды',
  'ops.backups.drills': 'Қалпына келтіру жаттығулары',
  'ops.backups.runDrill': 'Соңғы көшірме бойынша жаттығу',
  'ops.backups.runBackup': 'Қазір көшірме жасау',
  'ops.backups.running': 'Орындалуда…',
  'ops.backups.checkThis': 'Тексеру',
  'ops.backups.checkThisHint': 'Осы көшірмені уақытша базаға жайып, салыстыру',
  'ops.backups.doneBackup': 'Көшірме жасалды: {size}',
  'ops.backups.donePassed': 'Жаттығу өтті: {tables} кесте, айырма жоқ, {rto} с',
  'ops.backups.doneFailed': 'Жаттығу өтпеді: айырма {mismatches}',
  'ops.backups.restoreNote':
    'Жұмыс базасының үстіне қалпына келтіру мұнда әдейі жоқ: апат кезінде бұл панель сервермен бірге істен шығады, ал операция қайтымсыз. Қалпына келтіру тәртібі — operations/runbook-backup.md.',
  'ops.backups.rto': 'Қалпына келтіру уақыты, с',
  'ops.backups.mismatches': 'Алшақтықтар',
  'ops.backups.tables': 'Тексерілген кестелер',
  'ops.backups.passed': 'Өтті',
  'ops.backups.failed': 'Өтпеді',
  'ops.backups.note':
    'Мұнда база көшірмелері жасалып жатқаны және олар шынымен қалпына келетіні көрінеді. Жаттығу соңғы көшірмені уақытша базаға көтеріп, оны салыстырады: қалпына келтірілмеген көшірме көшірме саналмайды.',
  'ops.backups.toolsMissing': 'Бұл контурда көшірмелер мен жаттығулар қолжетімсіз',
  'ops.backups.toolsMissingWhy':
    'pg_dump және pg_restore утилиталары табылмады. Әзірлеуші машинасында postgresql-client әдетте орнатылмаған, ал база контейнерде тұрады — онда утилиталар сол контейнердің ішінде іске қосылады. .env файлында MOIKA_PG_TOOL_PREFIX="docker exec -i moika-pg", MOIKA_PG_TOOL_URL="postgresql://moika:moika@127.0.0.1:5432/moika" және MOIKA_BACKUP_DIR=/var/lib/postgresql/backups мәндерін беріп, серверді қайта қосыңыз. Өнеркәсіптік контурда утилиталар образда тұрады, префикс бос қалдырылады.',
  'ops.backups.toolsPrefix': 'Ағымдағы іске қосу префиксі',
  'ops.backups.toolsNotSet': 'берілмеген',

  'ops.residency.title': 'Сыртқы қызметтердің резиденттік тізілімі',
  'ops.residency.code': 'Коды',
  'ops.residency.name': 'Қызмет',
  'ops.residency.category': 'Санаты',
  'ops.residency.pii': 'Дербес деректерді өңдейді',
  'ops.residency.country': 'Орналасу елі',
  'ops.residency.verdict': 'Шешім',
  'ops.residency.evidence': 'Негіздеме',
  'ops.residency.pending': 'Тексерілмеген',
  'ops.residency.approved': 'Жіберілген',
  'ops.residency.rejected': 'Шығарылған',
  'ops.residency.compliant': 'Барлық қызметтер тексерілді',
  'ops.residency.incomplete': 'Тексерілмеген қызметтер: {n}',
  'ops.residency.note':
    'Дербес деректерді ҚР-дан тыс өңдейтін қызметті жіберуге болмайды — ТТ 8.4, ҚР № 94-V Заңы',
};

export type OpsKey = keyof typeof RU;
export type OpsTranslate = (key: OpsKey, params?: Readonly<Record<string, string | number>>) => string;

export function opsStrings(locale: Locale): OpsTranslate {
  const dict: Record<string, string> = locale === 'kk' ? KK : RU;
  return (key, params) => {
    const template = dict[key] ?? key;
    if (!params) return template;
    return template.replace(/\{(\w+)\}/g, (match, name: string) =>
      params[name] === undefined ? match : String(params[name]),
    );
  };
}
